module.exports = __webpack_public_path__ + "static/img/service-support.b129e89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service-support.png
// module id = 3gzk
// module chunks = 10